var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4 9.384-2.448 2.444a.596.596 0 0 1-.44.172.596.596 0 0 1-.44-.172.594.594 0 0 1-.172-.439c0-.178.058-.324.173-.439l2.432-2.428c.241-.24.54-.36.895-.36.356 0 .654.12.895.36l2.432 2.428a.594.594 0 0 1 .173.439.594.594 0 0 1-.173.439.596.596 0 0 1-.44.172.596.596 0 0 1-.439-.172L4 9.384zm0-6.768L6.448.172A.596.596 0 0 1 6.888 0c.178 0 .324.057.44.172A.594.594 0 0 1 7.5.611a.594.594 0 0 1-.173.439L4.895 3.478c-.241.24-.54.36-.895.36-.356 0-.654-.12-.895-.36L.673 1.05A.594.594 0 0 1 .5.61C.5.433.558.287.673.172A.596.596 0 0 1 1.113 0c.177 0 .323.057.439.172L4 2.616z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableCollapse);
export default __webpack_public_path__ + "static/media/table-collapse.5cb6f2d2ba6fba1ea95daa8f8be151c5.svg";
export { ForwardRef as ReactComponent };